
import { defineComponent } from "vue";
import Tier from "../model/Tiers";
import ListItem from "./ListItem.vue";

export default defineComponent({
  components: { ListItem },
  name: "Tier",
  props: {
    image: String,
    name: String,
    value: {
      type: Tier,
      required: true,
    },
  },
  methods: {
    backersChanged: function (event) {
      this.tierChanged({
        cost: this.value.cost,
        maxBackers: event.target.value,
      });
    },
    costChanged: function (event) {
      this.tierChanged({
        cost: event.target.value,
        maxBackers: this.value.maxBackers,
      });
    },
    tierChanged: function ({ cost = null, maxBackers = null }) {
      this.$emit("changed", {
        cost,
        maxBackers,
        backers: 0,
      });
    },
  },
});
